module.exports = __webpack_public_path__ + "static/media/_ProductPurchase.4533434b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/ProductPurchase/alfakraft/_ProductPurchase.scss
// module id = 558
// module chunks = 0